import { useEffect, useState, type RefObject } from "react";
import type { WbBoardScene } from "../lib/board/wb-board-scene";

/** Локальный просмотр + синхронная трансляция PDF (displayMode в scene). */
export function usePdfPresentation(
  sceneRef: RefObject<InstanceType<typeof WbBoardScene> | null>,
  ready: boolean
) {
  const [localPresentationPdfId, setLocalPresentationPdfId] = useState<string | null>(null);
  const [broadcastPdfId, setBroadcastPdfId] = useState<string | null>(null);
  const [sceneTick, setSceneTick] = useState(0);

  useEffect(() => {
    if (!ready) return;
    const scene = sceneRef.current;
    if (!scene) return;

    function syncBroadcast() {
      const found = scene!
        .getObjects()
        .find((o) => o.type === "pdf_document" && o.displayMode === "presentation");
      setBroadcastPdfId(found?.id ?? null);
      setSceneTick((n) => n + 1);
    }

    syncBroadcast();
    const unsub = scene.store.subscribe(syncBroadcast);
    return unsub;
  }, [ready, sceneRef]);

  const activePresentationPdfId = broadcastPdfId ?? localPresentationPdfId;
  const isBroadcast = broadcastPdfId !== null;

  return {
    localPresentationPdfId,
    setLocalPresentationPdfId,
    broadcastPdfId,
    activePresentationPdfId,
    isBroadcast,
    sceneTick,
  };
}
